import { Button } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { useUser } from '~/hooks/useUser/useUser';
import { RouteId } from '~/routes/RouteId';

type RequestSubmittedProps = Pick<ChatMessageProps, 'role' | 'createdBy'> & {
  demandId: string;
  demandSequenceNumber?: string | null;
  disabled: boolean;
  profile: ReturnType<typeof useUser>['profile'];
};

export const RequestSubmitted = ({
  role,
  createdBy,
  demandId,
  demandSequenceNumber,
  profile,
  disabled,
}: RequestSubmittedProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeRequestSubmitStep' });
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    navigate(RouteId.demandDetail(demandId));
  }, [navigate, demandId]);
  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message.released', profile)}
      footer={
        <Restricted needs={{ permission: Permission.DemandList }}>
          <Button color="primary" variant="contained" disabled={disabled} onClick={onClick}>
            {t('button.demand', { demandSequenceNumber })}
          </Button>
        </Restricted>
      }
    />
  );
};
